import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ProfilesSinglePersona from './ProfilesSinglePersona';
import ProfilesDoubleComparisionPersona from './ProfilesDoubleComparisionPersona';
import ProfilesTripleComparisionPersona from './ProfilesTripleComparisionPersona';
import downloadIconDefault from '../../../images/insight360/download-icon_default.png';
import { INGSIGHT_360_PROFILE_REPORT_NAME } from '../../../constants';
import indexIconwhite from '../../../images/index-icon_white.png';
import percentIconWhite from '../../../images/percent-icon_white.png';
import { getsortByKeyBasedOnSelectedTab } from '../../../util/Insight360Utils';


class Profiles extends Component {

  componentDidMount() {
    this.initiateAttitudeContentLoad();
  }

  componentDidUpdate() {
    this.initiateAttitudeContentLoad();
  }

  initiateAttitudeContentLoad() {
    const profileElement = document.getElementById('profile-container');
    const divHeight = profileElement.clientHeight;
    const windowHeight = window.innerHeight;
    if (divHeight !== 0 && divHeight < windowHeight) {
      this.props.loadAttitudeContent();
    }
  }

  render() {
    const { selectedTab, sortByKey, pcSortByKey } = this.props;
    return (
      <div id="profile-container">
        {this.props.profileBrands !== undefined &&
          this.props.profileBrands.length > 0 &&
          // this.props.medias !== undefined &&
          // this.props.medias.length > 0 &&
          this.props.profiles !== undefined &&
          this.props.profiles.length > 0 && (
          <div className="card main-card">
            <div className="card-header header-card">Profiles
              <span className="section-sort-by-index-reach-btns">
                <button
                  className="section-sort-icon index"
                  title="Index"
                  style={{
                    background: getsortByKeyBasedOnSelectedTab(selectedTab, sortByKey, pcSortByKey, 'index'),
                  }}
                  onClick={() => {
                    this.props.sectionSortingByIndexAndReach(INGSIGHT_360_PROFILE_REPORT_NAME, 'index');
                  }}
                >
                  <img
                    className="profile-section-sort-icon"
                    src={indexIconwhite}
                  />
                </button>
                <button
                  className="section-sort-icon reach"
                  title="Reach"
                  style={{
                    background: getsortByKeyBasedOnSelectedTab(selectedTab, sortByKey, pcSortByKey, 'pct'),
                  }}
                  onClick={() => {
                    this.props.sectionSortingByIndexAndReach(INGSIGHT_360_PROFILE_REPORT_NAME, 'pct');
                  }}
                >
                   <img
                     className="profile-section-sort-icon"
                     src={percentIconWhite}
                   />
                </button>
              </span>
            </div>
            <div className="row expanded card-section" id="cardOutlook">
              {/* <div className="text-right">
                <img onClick={() => {
                  this.props.download("Profile", "profile", "profilePersonaGrid", "personaHeader")
                }} className="export-icon-class" src={downloadIconDefault} />
              </div> */}
              <div className="large-12 medium-12 small-12 columns">
                {this.props.downloadFlag && (
                  <div className="text-right">
                    <button
                      type="button"
                      onClick={() =>
                        this.props.download(
                          'Profile',
                          'Profiles',
                          'profilePersonaGrid',
                          'personaHeader',
                        )
                      }
                      className="export-icon-class"
                    >
                      <img alt="" src={downloadIconDefault} />
                    </button>
                  </div>
                )}
                <div>&nbsp;</div>
              </div>
              <div id="profilePersonaGrid">
                { this.props.profileBrands !== undefined &&
                  this.props.profileBrands.length === 1 &&
                  this.props.medias !== undefined &&
                 this.props.medias.length === 1 &&
                 this.props.profiles !== undefined &&
                  this.props.profiles.length === 1 && (
                  <ProfilesSinglePersona
                    brands={this.props.profileBrands[0]}
                    profile={this.props.profiles[0]}
                    media={this.props.medias[0]}
                    insight360studyInfo={this.props.insight360studyInfo}
                  />
                  )}
                { this.props.profileBrands !== undefined &&
                  this.props.profileBrands.length === 2 &&
                  this.props.medias !== undefined &&
                  this.props.medias.length === 2 &&
                  this.props.profiles !== undefined &&
                  this.props.profiles.length === 2 && (
                  <ProfilesDoubleComparisionPersona
                    brands={this.props.profileBrands}
                    profiles={this.props.profiles}
                    medias={this.props.medias}
                    insight360studyInfo={this.props.insight360studyInfo}
                  />
                  )}
                {this.props.profileBrands !== undefined &&
                  this.props.profileBrands.length === 3 &&
                  this.props.medias !== undefined &&
                  this.props.medias.length === 3 &&
                  this.props.profiles !== undefined &&
                  this.props.profiles.length === 3 && (
                  <ProfilesTripleComparisionPersona
                    brands={this.props.profileBrands}
                    profiles={this.props.profiles}
                    medias={this.props.medias}
                    insight360studyInfo={this.props.insight360studyInfo}
                  />
                  )}
              </div>
              {this.props.sourceDataInfo()}
            </div>
            <div id={this.props.endId} />
          </div>
        )}
      </div>
    );
  }
}

Profiles.propTypes = {
  loginResponse: PropTypes.shape({
    data: PropTypes.shape({
      /* uid: PropTypes.number, */
      /* token: PropTypes.string, */
    }),
  }),
  profiles: PropTypes.arrayOf(PropTypes.object),
  brands: PropTypes.arrayOf(PropTypes.object),
  medias: PropTypes.arrayOf(PropTypes.object),
  download: PropTypes.func,
  loadAttitudeContent: PropTypes.func,
  sourceDataInfo: PropTypes.string,
  selectedTab: PropTypes.string,
  sortByKey: PropTypes.string,
  pcSortByKey: PropTypes.string,
  sectionSortingByIndexAndReach: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    loginResponse: state.login.loginResponse,
    sortByKey: state.insight360.sortByIndexAndReach.profiles,
    pcSortByKey: state.insight360.personaCreator.sortByIndexAndReach.profiles,
  };
}

function mapDispatchToProps() {
  return {
    // brand360Actions: bindActionCreators(brand360Actions, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(Profiles);
